// src/modules/app-views/invoices/pages/Init/components/tableColumns/invoiceOperationTypeColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Invoices-only operation type column (exit/entry).
function invoiceOperationTypeColumn(buildColumnProps) {
  return {
    title: translateX('operation'),
    dataIndex: 'operationType',
    ...buildColumnProps('operationType', { sort: true }),
    width: 90,
    align: 'center',
    render: (_, record) => {
      const type = record?.operationType;
      if (!type) return '—';
      return <Text>{translateX(type === 'exit' ? 'operation_exit' : 'operation_entry')}</Text>;
    },
  };
}

export default invoiceOperationTypeColumn;
